import { render, staticRenderFns } from "./SuccessAdd.vue?vue&type=template&id=0fc4a942&scoped=true"
import script from "./SuccessAdd.vue?vue&type=script&lang=js"
export * from "./SuccessAdd.vue?vue&type=script&lang=js"
import style0 from "./SuccessAdd.vue?vue&type=style&index=0&id=0fc4a942&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc4a942",
  null
  
)

export default component.exports